import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Avatar,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const SuperAdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState("");
  const [logoutAnchorEl, setLogoutAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const open = Boolean(anchorEl);
  const logoutMenuOpen = Boolean(logoutAnchorEl);
  const user = JSON.parse(localStorage.getItem("user"));

  const handleMenuOpen = (e, menuName) => {
    setAnchorEl(e.currentTarget);
    setOpenMenu(menuName);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setOpenMenu("");
  };

  const handleLogoutMenuOpen = (event) => {
    setLogoutAnchorEl(event.currentTarget);
  };

  const handleLogoutMenuClose = () => {
    setLogoutAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setLogoutAnchorEl(null);
    navigate("/");
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleMenuClose();
    setDrawerOpen(false);
  };

  const drawerItems = [
    { label: "Create > Customer", path: "/super-admin/customers" },
    { label: "Create > Product", path: "/super-admin/product" },
    { label: "Create > Unit", path: "/super-admin/unit/view" },
    { label: "S Challan", path: "/super-admin/schallan/view" },
    { label: "P Challan", path: "/super-admin/pchallan/view" },
    { label: "Transaction > Receipt", path: "/super-admin/receipt/view" },
    { label: "Transaction > Payment", path: "/super-admin/payment/view" },
    { label: "Transaction > Ledger", path: "/super-admin/ledger" },
    { label: "Transaction > Cashbook", path: "/super-admin/cashbook" },
    { label: "Report > Balance Report", path: "/super-admin/balance-report" },
    { label: "Report > Stock Report", path: "/super-admin/stock-report" },
    { label: "Report > Purchase Report", path: "/super-admin/purchase-report" },
    {
      label: "Report > Product Purchase",
      path: "/super-admin/product-wise-purchase-report",
    },
    { label: "Report > Sales Report", path: "/super-admin/sales-report" },
    {
      label: "Report > Product Sales",
      path: "/super-admin/product-wise-sales-report",
    },
    { label: "Report > Price List", path: "/super-admin/price-list" },
  ];

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <AppBar position="fixed" color="primary">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box display="flex" alignItems="center">
            {isMobile && (
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setDrawerOpen(true)}
                sx={{ mr: 1 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Typography variant="h6" noWrap>
              Rupioo DMS
            </Typography>
          </Box>

          {!isMobile && (
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                color="inherit"
                onClick={(e) => handleMenuOpen(e, "create")}
              >
                Create
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={openMenu === "create"}
                onClose={handleMenuClose}
              >
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/customers")}
                >
                  Customer
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/product")}
                >
                  Product
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/unit/view")}
                >
                  Unit
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/user/view")}
                >
                  User
                </MenuItem>
              </Menu>

              <Button
                color="inherit"
                onClick={() => handleNavigate("/super-admin/schallan/view")}
              >
                S Challan
              </Button>
              <Button
                color="inherit"
                onClick={() => handleNavigate("/super-admin/pchallan/view")}
              >
                P Challan
              </Button>
              <Button
                color="inherit"
                onClick={() => handleNavigate("/super-admin/order/view")}
              >
                Order
              </Button>
              <Button
                color="inherit"
                onClick={() => handleNavigate("/super-admin/production/view")}
              >
                Production
              </Button>
              <Button
                color="inherit"
                onClick={() => handleNavigate("/super-admin/attendance")}
              >
                Attendance
              </Button>

              <Button
                color="inherit"
                onClick={(e) => handleMenuOpen(e, "transaction")}
              >
                Transaction
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={openMenu === "transaction"}
                onClose={handleMenuClose}
              >
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/receipt/view")}
                >
                  Receipt
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/payment/view")}
                >
                  Payment
                </MenuItem>
                <MenuItem onClick={() => handleNavigate("/super-admin/ledger")}>
                  Ledger
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/cashbook")}
                >
                  Cashbook
                </MenuItem>
              </Menu>

              <Button
                color="inherit"
                onClick={(e) => handleMenuOpen(e, "report")}
              >
                Report
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={openMenu === "report"}
                onClose={handleMenuClose}
              >
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/balance-report")}
                >
                  Balance Report
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/stock-report")}
                >
                  Stock Report
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/purchase-report")}
                >
                  Purchase Report
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleNavigate("/super-admin/product-wise-purchase-report")
                  }
                >
                  Product Wise Purchase
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/sales-report")}
                >
                  Sale Report
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleNavigate("/super-admin/product-wise-sales-report")
                  }
                >
                  Product Wise Sale
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigate("/super-admin/price-list")}
                >
                  Price List
                </MenuItem>
              </Menu>
            </Box>
          )}

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={handleLogoutMenuOpen}>
              <Avatar sx={{ width: 32, height: 32, mr: 1 }} />
              <Typography variant="body1">
                {user?.name || "SuperAdmin"}
              </Typography>
            </IconButton>
            <Menu
              anchorEl={logoutAnchorEl}
              open={logoutMenuOpen}
              onClose={handleLogoutMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 240 }} role="presentation">
          <List>
            {drawerItems.map((item, idx) => (
              <ListItem
                button
                key={idx}
                onClick={() => handleNavigate(item.path)}
              >
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
            <ListItem button onClick={handleLogout}>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        flexGrow={1}
        sx={{ mt: 8, mb: 8, overflowY: "auto" }}
      >
        <Container minWidth="screen">{children}</Container>
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          height: "64px",
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2">
          © {new Date().getFullYear()} DMS
        </Typography>
      </Box>
    </Box>
  );
};

export default SuperAdminLayout;
